import React, { FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ClTitle from 'components/clientComp/clTitle';
import Avatar from 'assets/imgs/about/avatar.png';
import { aboutMeWidgetData } from 'configs/aboutMeWidgetData';

import './ClAbout.scss';

const ClAbout: FC = () => {
  return (
    <Container fluid className="cl-about">
      <ClTitle titleNumber={'01'} title={'About me'} subTitle={'get to know'} />
      <Row className="cl-about-container">
        <Col className="cl-about-left d-flex justify-content-center align-items-center">
          <div
            data-aos="zoom-in"
            data-aos-duration="1000"
            className="cl-about-left__container"
          >
            <div className="image-container">
              <img src={Avatar} alt="jay-portfolio" />
              <div className="bg-blur" />
            </div>
          </div>
        </Col>
        <Col className="cl-about-right">
          <div className="cl-about-right__container">
            <div className="widget-container">
              {aboutMeWidgetData.map((val, index) => {
                return (
                  <div
                    data-aos="zoom-in"
                    data-aos-duration="1000"
                    key={index}
                    className="widget-item"
                  >
                    {val.icon}
                    <h6 className="widget-label">{val.label}</h6>
                    <p className="desc">{val.description}</p>
                  </div>
                );
              })}
            </div>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              className="about-content"
            >
              <p className="desc">
                Hello! My name is Thien Nhan (you can call me Jay) and I come
                from Viet Nam. My interest in web development started back in
                2014 when I was a student at university and I decided to be a
                Frontend Developer after three years I worked as HR staff. I was
                an intern at Nexlab Technology, and now I am a Frontend
                Developer at a technology company and a freelancer.
              </p>
            </div>
            <a href="#contact" data-aos="zoom-in" className="download-resume">
              Let's Talk
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ClAbout;
